import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import axios from "axios";
import SignUpPage from "./Pages/SignUpPage";
import SuccessPage from "./Pages/SuccessPage";
import VerifyEmail from "./Pages/VerifyEmail";
import PaymentForm from "./Pages/PaymentPage";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import PaymentUpgradeForm from "./Pages/PaymentUpgradePage";
import { Download } from "@mui/icons-material";
import SharedFileScreen from "./Pages/SharedFileScreen";
import "@fontsource/plus-jakarta-sans"; // Defaults to 400
import "@fontsource/plus-jakarta-sans/700.css"; // Optional weights
import "@fontsource/plus-jakarta-sans/600.css"; // Optional weights
import "@fontsource/plus-jakarta-sans/500.css"; // Optional weights
import Otp_in from "./Pages/Otp_in";

export const serverURL = "https://api.synkoria.com/";
// export const serverURL = "http://localhost:9000/";

axios.defaults.baseURL = serverURL;

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/:qr_uuid" exact element={<Home />} />
          <Route
            path="/contact_user_id/:user_code"
            exact
            element={<SignUpPage />}
          />
          <Route
            path="/contact_user_id/:user_code/:templete_uuid"
            exact
            element={<SignUpPage />}
          />
          <Route path="/group_id/:group_uuid" exact element={<SignUpPage />} />
          <Route path="/rsvp/:qr_uuid" exact element={<SignUpPage />} />
          <Route path="/success/:val" exact element={<SuccessPage />} />
          <Route
            path="/verify/:user_uuid/:user_code"
            exact
            element={<VerifyEmail />}
          />
          <Route
            path="/registration-form/payment"
            exact
            element={
              <>
                <Header />
                <PaymentForm />
                <Footer />
              </>
            }
          />
          <Route
            path="/registration-form/payment/:selected_plan"
            exact
            element={
              <>
                <Header />
                <PaymentForm /> <Footer />
              </>
            }
          />
          <Route
            path="/upgrade-form/payment"
            exact
            element={
              <>
                <Header />
                <PaymentUpgradeForm />
                <Footer />
              </>
            }
          />
          <Route
            path="/upgrade-form/payment/:selected_plan"
            exact
            element={
              <>
                <Header />
                <PaymentUpgradeForm /> <Footer />
              </>
            }
          />
          <Route
            path="/opt-in"
            exact
            element={
              <>
                <Header />
                <Otp_in />
                <Footer />
              </>
            }
          />
          <Route
            path="/"
            element={
              <>
                <Header />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "50px",
                    flexDirection: "column",
                  }}
                >
                  <h1 style={{ textAlign: "center" }}>
                    Download the app to get started
                  </h1>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "50px",
                    }}
                  >
                    <PlayStoreButton />
                    <AppStoreButton />
                  </div>
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/downloadSharedFile/:link_uuid"
            element={<SharedFileScreen />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
const PlayStoreButton = () => (
  <a
    href={serverURL + "playStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/playstore.png"
      alt="play store"
      style={{ width: "150px", marginRight: "25px" }}
    />
  </a>
);

const AppStoreButton = () => (
  <a
    href={serverURL + "appStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/appstore.png"
      alt="app store"
      style={{ width: "150px" }}
    />
  </a>
);
